import { Card } from "react-bootstrap";
import { useDispatch } from "react-redux";

import AddIcon from "../../components/common/AddIcon";
import {
  clearFormBetOption,
  toggleBetOptionModal,
} from "./redux/betOptionSlice";
import BetOptionAccordion from "./components/BetOptionAccordion";
import { useBetOptionQuery } from "../../graphql/apollo/query-hooks";

const BetOption = () => {
  const dispatch = useDispatch();

  const handleAdd = () => {
    dispatch(clearFormBetOption());
    dispatch(toggleBetOptionModal());
  };
  const { betOptionList } = useBetOptionQuery();

  return (
    <>
      <Card>
        <Card.Header>
          <Card.Title>
            <h3 className="p-1">ຈັດການຂໍ້ມູນເດີມພັນ</h3>
          </Card.Title>
          <AddIcon onClick={handleAdd} />
        </Card.Header>
        <Card.Body>
          <BetOptionAccordion data={betOptionList} />
        </Card.Body>
      </Card>
    </>
  );
};

export default BetOption;
